import { ModuleWithProviders, NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as versionEffects from './version.effects';
import { versionFeature } from './version.reducer';

@NgModule({
  imports: [StoreModule.forFeature(versionFeature)],
})
export class VersionStateModule {
  static forRoot(useServiceWorker: boolean): ModuleWithProviders<VersionStateModule> {
    return {
      ngModule: VersionStateModule,
      providers: [
        ...(ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: useServiceWorker,
        }).providers ?? []),
        ...(EffectsModule.forFeature(useServiceWorker ? [versionEffects] : []).providers ?? []),
      ],
    };
  }
}
